import React, { useContext } from 'react'
import TimeTableContext from '../context/timeTableContext'
import DailyChanges from './parts/changesViews/DailyChanges'
import WeeklyChanges from './parts/changesViews/WeeklyChanges'
import AllChanges from './parts/changesViews/AllChanges'

const Changes = () => {
  const context = useContext(TimeTableContext)
  let screen = <DailyChanges />

  if (context.state.currentChangesScreen === 1) {
    screen = <DailyChanges />
  } else if (context.state.currentChangesScreen === 2) {
    screen = <WeeklyChanges />
  } else if (context.state.currentChangesScreen === 3) {
    screen = <AllChanges />
  }
  let today = new Date()
  let dayName = context.state.daysOfTheWeek[today.getDay()]

  return (
    <div className='container-fluid text-center'>
      <h3>
        שינויים במערכת {dayName} {today.toLocaleDateString()}
      </h3>
      {/* <div className="btn-group" role="group" aria-label="Basic example">
            <button type="button" className="btn btn-secondary" onClick={(e) => context.dispatch({"type":"SET_CURRENT_CHANGES_SCREEN","payload":1})}>תצוגה יומית</button>
            <button type="button" className="btn btn-secondary" onClick={(e) => context.dispatch({"type":"SET_CURRENT_CHANGES_SCREEN","payload":2})}>תצוגה שבועית</button>
            <button type="button" className="btn btn-secondary" onClick={(e) => context.dispatch({"type":"SET_CURRENT_CHANGES_SCREEN","payload":3})}>כל השינויים</button>
          </div> */}

      <div className='changes-view'>{screen}</div>
    </div>
  )
}

export default Changes
